import { render, staticRenderFns } from "./MenuInterno.vue?vue&type=template&id=4e9392ba&scoped=true&"
import script from "./MenuInterno.vue?vue&type=script&lang=js&"
export * from "./MenuInterno.vue?vue&type=script&lang=js&"
import style0 from "./MenuInterno.vue?vue&type=style&index=0&id=4e9392ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9392ba",
  null
  
)

export default component.exports